import { render, staticRenderFns } from "./CarMainBanner.vue?vue&type=template&id=354d39af&scoped=true"
import script from "./CarMainBanner.vue?vue&type=script&lang=js"
export * from "./CarMainBanner.vue?vue&type=script&lang=js"
import style0 from "./CarMainBanner.vue?vue&type=style&index=0&id=354d39af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d39af",
  null
  
)

export default component.exports